/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_ShutterInputs */

const en_us2_body_assessment_shutter = /** @type {(inputs: Body_Assessment_ShutterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take the photo`)
};

const pt_br2_body_assessment_shutter = /** @type {(inputs: Body_Assessment_ShutterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tirar a foto`)
};

const es_419_body_assessment_shutter = /** @type {(inputs: Body_Assessment_ShutterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomar la foto`)
};

const pt_pt2_body_assessment_shutter = /** @type {(inputs: Body_Assessment_ShutterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tirar a foto`)
};

const fr_fr2_body_assessment_shutter = /** @type {(inputs: Body_Assessment_ShutterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prendre la photo`)
};

const de_de2_body_assessment_shutter = /** @type {(inputs: Body_Assessment_ShutterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto machen`)
};

const it_it2_body_assessment_shutter = /** @type {(inputs: Body_Assessment_ShutterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scatta la foto`)
};

/**
* | output |
* | --- |
* | "Take the photo" |
*
* @param {Body_Assessment_ShutterInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_shutter = /** @type {((inputs?: Body_Assessment_ShutterInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_ShutterInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_shutter(inputs)
	if (locale === "es-419") return es_419_body_assessment_shutter(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_shutter(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_shutter(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_shutter(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_shutter(inputs)
	return en_us2_body_assessment_shutter(inputs)
});
export { body_assessment_shutter as "body-assessment.shutter" }